import { AuthTokenStorage } from "module/auth/AuthTokenStorage";
import { useEffect, useState } from "react";
import { useResetRecoilState, useSetRecoilState } from "recoil";
import { useQueryClient } from "react-query";
import { UserService } from "module/api/service";
import { authState, UserType } from "module/auth/AuthState";
import { posthog } from "utils/posthog";

export function useLoad(): boolean {
    const [loading, setLoading] = useState(true);
    const queryClient = useQueryClient();
    const setAuthState = useSetRecoilState(authState);
    const resetAuthState = useResetRecoilState(authState);
    useEffect(() => {
        const load = async () => {
            const token = AuthTokenStorage.get();
            try {
                if (token) {
                    const data = await queryClient.fetchQuery("me", UserService.userControllerGetMe);
                    setAuthState({ token: token, isLogged: true, role: data.type as UserType });
                    if (posthog.__loaded) posthog.identify(String(data.id), { role: data.type });
                }
            } catch (e) {
                const error = e as any;
                if (error?.body?.statusCode === 401 || error?.status === 401) {
                    await AuthTokenStorage.clear();
                    resetAuthState();
                } else if (error?.status === 404) {
                    // 404 - користувач не знайдений, очищаємо токен
                    await AuthTokenStorage.clear();
                    resetAuthState();
                } else {
                    // Інші помилки не ламають завантаження
                    // eslint-disable-next-line no-console
                    console.debug("Error loading user:", error);
                }
            }
            // OTHER STUFF
            setLoading(false);
        };
        load();
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return loading;
}
